export function isHex(num: string) {
  return Boolean(num.match(/^0x[0-9a-f]+$/i));
}
